<div class="modal-header">
  <h4 class="modal-title">{{ 'chat.forward.title' | translate }}</h4>
  <button type="button" class="btn-close" [attr.aria-label]="'chat.dialog.cancel' | translate" (click)="close()"></button>
</div>

<div class="modal-body">
  <!-- Forwarded content preview — the original author is identified server-side
       via forwardedFrom on the delivered copy (RF-13/AC-11). -->
  @if (data?.preview) {
    <div class="alert alert-secondary d-flex align-items-start gap-2 py-2 mb-3" role="note">
      <i class="ri-share-forward-line flex-shrink-0"></i>
      <small class="text-truncate">{{ data.preview }}</small>
    </div>
  }

  <label class="form-label" for="chatForwardFilter">{{ 'chat.forward.destination' | translate }}</label>
  <input
    id="chatForwardFilter"
    type="text"
    class="form-control mb-2"
    name="chatForwardFilter"
    [placeholder]="'chat.forward.searchDestination' | translate"
    [attr.aria-label]="'chat.forward.searchDestination' | translate"
    [(ngModel)]="filterTerm"
    (input)="applyFilter()"
  >

  @if (filteredTargets.length === 0) {
    <div class="text-center text-muted py-4">{{ 'chat.forward.noDestination' | translate }}</div>
  } @else {
    <div class="list-group list-group-flush chat-forward-list overflow-auto">
      @for (target of filteredTargets; track trackTarget($index, target)) {
        <button
          type="button"
          class="list-group-item list-group-item-action d-flex align-items-center gap-2 py-2"
          [class.active]="isSelected(target)"
          (click)="select(target)"
        >
          <span class="avatar-xs rounded-circle bg-soft-primary flex-shrink-0">
            <i class="avatar-title text-primary" [ngClass]="target.icon"></i>
          </span>
          <span class="flex-grow-1 chat-name text-start">{{ target.name }}</span>
          @if (isSelected(target)) {
            <i class="ri-checkbox-circle-fill text-primary flex-shrink-0"></i>
          } @else {
            <i class="ri-checkbox-blank-circle-line text-muted flex-shrink-0"></i>
          }
        </button>
      }
    </div>
  }

  <div class="mt-3">
    <label class="form-label" for="chatForwardComment">{{ 'chat.forward.comment' | translate }}</label>
    <textarea
      id="chatForwardComment"
      class="form-control"
      rows="2"
      name="chatForwardComment"
      [placeholder]="'chat.forward.commentPlaceholder' | translate"
      [(ngModel)]="comment"
    ></textarea>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="close()">{{ 'chat.dialog.cancel' | translate }}</button>
  <button type="button" class="btn btn-primary" [disabled]="!selectedId || submitting" (click)="confirm()">
    @if (submitting) {
      <span class="spinner-border spinner-border-sm me-1" role="status"></span>
      <span>{{ 'chat.forward.sending' | translate }}</span>
    } @else {
      <span>{{ 'chat.forward.confirm' | translate }}</span>
    }
  </button>
</div>
